import { Text } from '@telegram-apps/telegram-ui';
import { type FC, useMemo } from 'react';
import { voiceActionDisplayTitle } from '../../helpers/voiceActionDisplay';
import { VoiceAction } from '../../types/voice';

interface ActionCardTitleProps {
  action: VoiceAction;
}

export const ActionCardTitle: FC<ActionCardTitleProps> = ({ action }) => {
  const displayName = useMemo(() => voiceActionDisplayTitle(action), [action]);

  return (
    <Text
      style={{
        fontSize: 14,
        fontWeight: 600,
        color: 'var(--tg-theme-text-color)',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      }}
    >
      {displayName}
    </Text>
  );
};
